import { axios } from '@/lib/axios';

export const APIdeleteTenant = (tenantId: string): Promise<void> => {
    const params = {
        ids: [tenantId]
    };
    return axios.delete(`/tenant`, { params });
};
